import amplitude from '../util/analytics/amplitude';
import { track, setUserProperties } from '../util/analytics/amplitude.util';

export const trackSmsAccountProvisioningStart = (eventSource, isSpaApp) => {
    setUserProperties({
        [amplitude.keap.events.MARKETING_NUMBER_PROVISIONED]: false,
    }, isSpaApp);

    track(amplitude.keap.events.TEXT_BEGIN_MARKETING_NUMBER_PROVISIONING, {
        'Event Source': eventSource,
    },
    isSpaApp);
};

export const trackSmsFeatureDiscovered = (eventSource, isSpaApp) => {
    track(amplitude.keap.events.TEXT_MARKETING_DISCOVERED, {
        'Event Source': eventSource,
    },
    isSpaApp);
};

export const trackSmsAutomationCreated = (eventSource, isSpaApp) => {
    track(amplitude.keap.events.TEXT_MARKETING_AUTOMATION_CREATED, {
        'Event source': eventSource,
        Type: 'SMS',
    },
    isSpaApp);
};

export const trackSmsAccountProvisioningComplete = (eventSource, isSpaApp) => {
    setUserProperties({
        [amplitude.keap.events.MARKETING_NUMBER_PROVISIONED]: true,
    }, isSpaApp);

    track(amplitude.keap.events.TEXT_COMPLETE_MARKETING_NUMBER_PROVISIONING, {
        'Event Source': eventSource,
    },
    isSpaApp);
};

export const trackKmnTemplateInsert = (template, eventSource, isSpaApp) => {
    track(amplitude.keap.events.KMN_TEMPLATE_CHOSEN, {
        Source: eventSource,
        'Template content': template?.content,
        'Template title': template?.title,
        'Template Kind': template?.templateKind,
    },
    isSpaApp);
};

export const trackKmnTemplateCreated = (isSpaApp, source) => {
    track(amplitude.keap.events.KMN_TEMPLATE_CREATED, {
        Source: source,
    },
    isSpaApp);
};

export const trackKmnTemplateDeleted = (template, isSpaApp, source) => {
    track(amplitude.keap.events.KMN_TEMPLATE_DELETED, {
        Source: source,
        'Template content': template?.content,
        'Template title': template?.title,
        'Template Kind': template?.templateKind,
    },
    isSpaApp);
};

export const trackSmsBroadcastCreated = (isSpaApp) => {
    track(amplitude.keap.events.TEXT_BROADCAST_CREATED, {
        Edition: 'Max Classic',
    },
    isSpaApp);
};

export const trackSmsBroadcastWritten = (isSpaApp) => {
    track(amplitude.keap.events.TEXT_BROADCAST_WRITTEN, {
        Edition: 'Max Classic',
    },
    isSpaApp);
};

export const trackSmsBroadcastSent = (payload, isSpaApp) => {
    const {
        recipientCount,
        messageLength,
        phoneTypes,
        phoneFields,
        sendType,
    } = payload;

    track(amplitude.keap.events.TEXT_BROADCAST_SENT, {
        'Recipient Count': recipientCount,
        'Message Length': messageLength,
        'Phone Types': phoneTypes,
        'Phone Fields': phoneFields,
        'Send Type': sendType,
    },
    isSpaApp);
};

export const trackKmnBroadcastLimitExceeded = (payload, isSpaApp) => {
    const {
        appId,
        recipientCount,
        recipientsAdded,
    } = payload;

    track(amplitude.keap.events.KMN_BROADCAST_LIMIT_EXCEEDED, {
        'App ID': appId,
        'Recipient Count': recipientCount,
        Recipients: recipientsAdded,
    },
    isSpaApp);
};

export const trackKmnTemplatesManagerOpened = (isSpaApp, source) => {
    track(amplitude.keap.events.MANAGE_KMN_TEMPLATES, {
        Source: source,
    },
    isSpaApp);
};
